module.exports = __webpack_public_path__ + "img/xunidianchang-jutizhaopian.6fb6b64e.png";